<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12>
                    <div>
                        <v-layout row wrap fill-height class="pa-2 header">
                            <v-flex xs6 sm2>
                             <div class="title text-color">Visits</div>
                            </v-flex>
                            <v-flex xs12 sm10 class="filter_form">
                                <v-form @submit.prevent="validateBeforeSubmit('filterList')" data-vv-scope="filterList" id="filterList" ref="form">
                                    <v-layout row wrap>
                                        <v-flex xs6 sm4 md3>
                                            <v-text-field name="Name" label="Search By Name" id="name" regular single-line v-model="filters.name"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4 md2>
                                            <v-menu v-model="from_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field label="From Date" readonly v-on="on" regular single-line name="From date" v-model="filters.from_date" :error-messages="errors.collect('filterList.From Date')"></v-text-field>
                                                </template>
                                                <v-date-picker v-if="from_menu" v-model="filters.from_date" @input="from_menu = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 sm4 md2>
                                            <v-menu v-model="to_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field label="To Date" readonly v-on="on" regular single-line name="to date" v-model="filters.till_date" :error-messages="errors.collect('filterList.Till Date')"></v-text-field>
                                                </template>
                                                <v-date-picker v-if="to_menu" :min="this.filters.from_date" v-model="filters.till_date" @input="to_menu = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6 sm4 md3 class='buttoncenter pl-5'>
                                            <v-btn small color="primary" type="submit">Apply</v-btn>
                                            <v-btn small color="primary" class="btn_reset ml-1" @click="resetFilter">Reset</v-btn>
                                        </v-flex>
                                         <v-flex xs12 sm2 md2>
                                            <v-btn small color="primary ml-1" class="float_right" @click="exportvisitordata()" :disabled="!visits.length">Export</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-flex>

                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                 <v-data-table
                                    :headers="headers"
                                    :items="visits"
                                    item-key="id"
                                    class="elevation-1" 
                                    :server-items-length="total_items"
                                    :loading="is_loading" 
                                    :options.sync="options"
                                    :footer-props="{'items-per-page-options': [15, 20, 40, 80]}"                                
                                >
                                    <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td v-if="item.image">
                                                    <v-avatar size="36">
                                                        <img :src="storage_path()+item.image.path" @click="fullWidthImage(item.image.path)">
                                                    </v-avatar>
                                                </td>
                                                <td v-else>
                                                    <v-avatar size="36">
                                                        <img src="@/assets/images/index.png">
                                                    </v-avatar>
                                                </td>
                                             <td v-if="item.visitor!=null && item.visitor.id!=null"><router-link :to="{ name:'showVisitorDetails',params: { id:item.visitor.id } }">{{ item.visitor.name }}</router-link> 
                                                </td>
                                                <td v-else>-</td>
                                                <td v-if="item.visitor!=null && item.visitor.mobile!=null">{{ item.visitor.mobile}} </td>
                                                <td v-else>-</td>
                                                <td v-if="item.visitor!=null && item.visitor.email!=null">{{ item.visitor.email}}</td>
                                                <td v-else> - </td>
                                                <td v-if="item.purpose">{{ item.purpose}}</td>
                                                <td v-else>-</td>

                                                <td>{{ formatDateTime(item.time) }}</td>
                                                <td v-show="role!='Office Admin'" v-if="item.office!==null">
                                                    <router-link :to="{ name:'showOfficeDetails',params: { id:item.office.id } }">{{ item.office.name }}</router-link>
                                                </td>
                                                <td v-else> - </td>
                                                <td>{{ formatDate(item.created_at) }}</td>
                                                <div>
                                                        <td v-if="item.is_blacklisted!=null"> 
                                                            <div v-show="item.is_blacklisted.is_blacklisted=='1'">
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon color="red" dark v-on="on">mdi-alert</v-icon>
                                                                    </template>
                                                                            <span >Visitor is Blacklisted</span>
                                                                </v-tooltip>
                                                            </div>
                                                       </td><td v-else> </td>
                                                </div>
                                                <div></div>
                                            </tr>
                                        </tbody>
                                    </template>
                                     <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </div>
            </v-flex>
        </v-layout>

        <!-- Image Dialog -->

    <v-dialog
      v-model="image_dialog_box"
      max-width="290"
      max-height="290"
    >
      <v-card>
         <v-img :src="storage_path()+image_path" ></v-img> 
      </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
        options: {
            handler() {
                this.getList();
            }
        }
    },
    methods: {

      
        getList: function () {

            this.is_loading = true;
            this.options.filters = Object.assign({}, this.filters);
            axios.get(`${process.env.VUE_APP_API_URL}/api/visits`, {
                params: this.options
            }).then((response) => {
                if (response.data.status == 1) {
                    this.visits = response.data.visits_list.data;
                    this.total_items= response.data.visits_list.total;
                    this.count =this.total_items;
                    this.is_loading = false;

                }
            }).catch((error) => {
                console.log(error);
                this.is_loading = false;

            }).finally(() => {
                {

                }
            });

        },
        fullWidthImage(item_image){
            
            this.image_dialog_box =true;
            this.image_path = item_image;
            
        },
        exportvisitordata:function(){
             axios.post(`${process.env.VUE_APP_API_URL}/api/visits/exportvisits`,
             { params: this.options, responseType: 'blob'})
             .then((response)=>{
                 if(response.status == 200)
                    {   
                       this.download(response.data);
                     
                    }
              }).catch((error)=>{
                console.log(error);
              }).finally(()=>{

              });	
          
      },
    download(data){
     
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Visit_Report.csv');
      document.body.appendChild(link);
      link.click();
    },
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        filterList() {
            let filter_values = Object.values(this.filters);
            if (filter_values.join('').length > 0) {
                this.$router.replace({
                    name: "visits",
                    query: {
                        filters: true,
                        name: this.filters.name,
                        from_date: this.filters.from_date,
                        till_date: this.filters.till_date,

                    }
                });
                this.displayFilterChips(this.filters);
                this.is_filtered = true;
            } else {
                this.$router.replace({
                    name: "visits"
                });
            }
            this.getList();
            this.filter_dialog_box = false;
        },
        clearFilter: function (filter, key) {
            this.filter_chips[key] = this.filters[key] = '';
            this.filterList();
        },
        resetFilter() {
            this.resetFiltersParameters();
            this.$router.replace({
                name: 'visits',
                query: {}
            });
            this.getList();
            this.resetFiltersParameters();
            this.is_filtered = false;
            this.filter_dialog_box = false;
        },
        resetFiltersParameters: function () {
            for (var key in this.filters) {
                this.filters[key] = '';
                this.filter_chips[key] = '';
            }
        },
        applyFiltersOnLoad: function () {
            this.filters.name = this.$route.query.name;
            this.filters.from_date = this.$route.query.from_date;
            this.filters.till_date = this.$route.query.till_date;
            this.displayFilterChips(this.filters);
        },
        displayFilterChips: function (filters) {
            if (this.$route.query.filters) {
                this.filter_chips.name = filters.name;
                this.filter_chips.from_date = filters.from_date;
                this.filter_chips.till_date = filters.till_date;
                this.is_filtered = true;
            }
        },

        applycolumnfilter: function () {
            if (this.role == 'Office Admin') {
                this.headers = [{
                        text: 'Image',
                        align: 'left',
                        value: 'image',
                         sortable:false
                    },
                    {
                        text: 'Name',
                         sortable:false
                    },
                    {
                        text: 'Mobile',
                         sortable:false
                    },
                    {
                        text: 'Email',
                         sortable:false,
                    },
                    {
                        text: 'Purpose',
                         sortable:false,
                    },
                    {
                        text: 'Visit Date',
                         sortable:false
                    },
                    {
                        text: 'Created On',
                         sortable:false
                    },
                    {
                        text: '',
                        sortable:false
                    },
                   
                ];
            } else {
                this.headers = [{
                        text: 'Image',
                        align: 'left',
                         sortable:false
                    },
                    
                    {
                        text: 'Name',
                        value: 'visitor.name',
                        sortable:false
                    },
                    {
                        text: 'Mobile',
                        sortable:false
                    },
                    {
                        text: 'Email',
                        sortable:false
                    },
                     {
                        text: 'Purpose',
                         sortable:false,
                    },
                    {
                        text: 'Visit Date',
                         sortable:false
                    },
                    {
                        text: 'Office',
                        sortable:false
                    },
                    {
                        text: 'Created On',
                         sortable:false
                    },
                    {
                        text: '',
                        sortable:false
                    },
                    
                ];
            }
           
        }
    },
    data() {
        return {
            options: {},
            role: '',
            total_items: 0,
            count:"",
            headers: [],
            visits: [{
                type: '',
                visitor: {}
            }],

            filters: {
                name: '',
                from_date: '',
                till_date: '',
            },
            filter_chips: {
                name: '',
                from_date: '',
                till_date: '',
            },
            rowsPerPageItems: [10, 20, 30, 40],

            from_date_menu: false,
            to_date_menu: false,
            from_menu: false,
            to_menu: false,

            is_loading: false,
            is_filtered: false,
            default_visit_image: "/visits_images/index.png",
            image_dialog_box:false,
            image_path:"",

        }
    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        this.applycolumnfilter();
        this.applyFiltersOnLoad();
    },
};
</script>
